import { useEffect, useRef } from "react";

// Scrolls to the top of the given form element whenever `dep` changes
// (i.e. a multi-step form moves to a new step). Accounts for the fixed
// header and skips the initial mount. Uses Lenis when available.
export function useStepScroll(dep, ref) {
  const prev = useRef(dep);
  useEffect(() => {
    // No scroll on initial mount (incl. StrictMode double effect run):
    // only react to an actual change of `dep` caused by user interaction.
    if (prev.current === dep) return;
    prev.current = dep;
    const el = ref.current;
    if (!el) return;
    const HEADER_OFFSET = 100; // fixed header (+ possible announcement bar) breathing room
    const lenis = window.__lenis;
    if (lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(el, { offset: -HEADER_OFFSET, duration: 0.6 });
    } else {
      const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dep]);
}
